module.exports = __webpack_public_path__ + "static/media/Hotel-5@2x.66c666e1.png";